import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useSelector } from 'react-redux';

type chartPros = {
    seriesInternalData: number[],
    isShowReOpenTicketCounts: string
}

const TicketChrt = ({ seriesInternalData, isShowReOpenTicketCounts }: chartPros) => {
    const isDark = useSelector((state: any) => state.layout.isDark);

    const state: any = {
        series: [{
            name: 'Tickets',
            data: seriesInternalData
        }],
        options: {
            theme: {
                mode: isDark ? 'dark' : 'light',
            },
            chart: {
                type: 'bar',
                height: 350
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '55%',
                    endingShape: 'rounded'
                },
            },
            colors: ['#4669fa'],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            xaxis: {
                categories: [isShowReOpenTicketCounts === "Y" ? 'Re-Open' : 'Pending', 'Open', 'In-Process', 'Close'],
            },
            yaxis: {
                title: {
                    text: 'Tickets'
                }
            },
            tooltip: {
                y: {
                    formatter: function (val: any) {
                        return val + " Tickets"
                    }
                }
            },
        },
    };
    return (
        <div>
            <ReactApexChart options={state.options} series={state.series} type="bar" height={311} />
        </div >
    )
}

export default TicketChrt;
